exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#customer-menu{margin:0 5px;padding:0}#customer-menu li{padding:0}#customer-menu a{font-size:14px;padding:0 2px}#customer-menu h4{padding:0 12px;font-size:14px;margin:8px 0 0 0}\n", ""]);

